import { API } from '../../core/http/api'

export const getUserBoxes = async () => {
  const res = await API.get('boxes')
  if (res.status === 200) {
    return {
      serializedResults: res.data.results || [],
    }
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export async function moveBoxToAnotherLabel (data) {
  const res = await API.put(`boxes/labels/${data.boxId}`, data)

  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /boxes/labels')
  
  return res
}

export async function changeBoxAlias ({ boxId, boxAlias }) {
  const res = await API.put(`boxes/alias/${boxId}`,
    {
      boxId,
      boxAlias
    })

  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /boxes')
  return res
}

export const archiveBoxForUser = async (boxId) => {
  const res = await API.put(`boxes/archive/${boxId}`)
  if (res.status === 200) {
    return {
      serializedResults: res.data.results || [],
    }
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}
